import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-unsaved-sms-texts-dialog',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './unsaved-sms-texts-dialog.component.html',
  styleUrl: './unsaved-sms-texts-dialog.component.scss',
})
export class UnsavedSmsTextsDialogComponent {}
